/**
 * Calculates what percentage of an element is currently visible in the viewport.
 * Takes into account both vertical and horizontal visibility by calculating the
 * intersection between the element's bounding rectangle and the viewport dimensions.
 *
 * @param element - The DOM element to check visibility for
 * @returns A number between 0-100 representing the percentage of the element that is visible
 */
export function getVisibilityPercentage(element: Element) {
  const rect = element.getBoundingClientRect()
  const windowHeight = window.innerHeight || document.documentElement.clientHeight
  const windowWidth = window.innerWidth || document.documentElement.clientWidth

  // Calculate the intersection rectangle
  const intersectionTop = Math.max(rect.top, 0)
  const intersectionLeft = Math.max(rect.left, 0)
  const intersectionBottom = Math.min(rect.bottom, windowHeight)
  const intersectionRight = Math.min(rect.right, windowWidth)

  // If no intersection, return 0
  if (intersectionTop >= intersectionBottom || intersectionLeft >= intersectionRight) {
    return 0
  }

  // Calculate visible area
  const visibleWidth = intersectionRight - intersectionLeft
  const visibleHeight = intersectionBottom - intersectionTop
  const visibleArea = visibleWidth * visibleHeight

  // Calculate total element area
  const elementArea = rect.width * rect.height

  // Return percentage (0-100)
  return elementArea > 0 ? (visibleArea / elementArea) * 100 : 0
}
